import classNames from 'classnames';

const Message = ({ children, type }: any) => {
  return (
    <div
      className={classNames('px-5 py-4 w-full max-w-[550px]', {
        'text-yellow-700 bg-yellow-50 border border-solid border-yellow-200':
          type === 'warning',
      })}
    >
      {children}
    </div>
  );
};

export default Message;
